<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn
        class="px-2 ml-1"
        :color="item.colorPrinter"
        min-width="0"
        small
        :loading="loadingImprimir"
        v-on="on"
        @click="imprimirPedido(item)"
      >
        <v-icon class="white--text" small>mdi-printer</v-icon>
      </v-btn>
    </template>
    <span>Imprimir {{item.id}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
    },
  },
  data() {
    return {
      loadingImprimir: false,
    };
  },
  methods: {
    imprimirPedido(data) {
      const _vm = this;
      this.$confirm("¿Quiere imprimir el ticket?", {
        buttonTrueText: "Si",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((res) => {
          if (res) {
            _vm.loadingImprimir = true;
            return this.$store.dispatch("pedidos/imprimirPedido", data);
          } else {
            return Promise.reject("cancelar");
          }
        })
        .then((r) => {
          const d = r.data;
          if (d.ok) {
            this.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Ticket impreso",
            });
          } else {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al imprimir el ticket: " + d.error,
            });
          }
        })
        .catch((e) => {
          if (e != "cancelar") {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al imprimir el ticket: " + e,
            });
          }
        })
        .finally(() => (_vm.loadingImprimir = false));
    },
  },
};
</script>

<style>
</style>